const keys = {
  all: ['records'],
  record: id => [...keys.all, { recordId: parseInt(id, 10) }],
  recordPolicies: id => [...keys.record(id), 'policies'],
  activeRecordPolicies: id => [...keys.recordPolicies(id), 'active'],
  archivedRecordPolicies: id => [...keys.recordPolicies(id), 'archived'],
  recordDocuments: id => [...keys.record(id), 'documents'],
  activeRecordDocuments: id => [...keys.recordDocuments(id), 'active'],
  archivedRecordDocuments: id => [...keys.recordDocuments(id), 'archived'],
  recordPolicyRequirements: id => [...keys.record(id), 'policy_requirements'],
  recordItemRequirements: id => [...keys.record(id), 'item_requirements'],
  recordDocumentRequirements: id => [...keys.record(id), 'document_requirements'],
  recordLanguageRequirements: id => [...keys.record(id), 'language_requirements'],
  recordQuestionRequirements: id => [...keys.record(id), 'question_requirements'],
  recordGptRequests: id => [...keys.record(id), 'gpt_requests'],
  recordGptRequest: (id, gptRequestId) => [...keys.record(id), 'gpt_requests', { gptRequestId: parseInt(gptRequestId, 10) }],
  recordAttachments: id => [...keys.record(id), 'attachments'],
  recordWatchers: id => [...keys.record(id), 'watchers'],
  // Keyed by batch id only: a clone batch is owned by its creator, not by a record.
  recordCloneBatch: batchId => ['record-clone-batches', { batchId }],
  companyActiveRecordsSearch: (companyId, { searchTerm = '', excludeRecordId = null, excludeInsuredId = null } = {}) => [
    ...keys.all,
    'company-active-records-search',
    {
      companyId: parseInt(companyId, 10),
      searchTerm,
      excludeRecordId: excludeRecordId ? parseInt(excludeRecordId, 10) : null,
      excludeInsuredId: excludeInsuredId ? parseInt(excludeInsuredId, 10) : null
    }
  ],
  // Scoped by insurance document id, NOT record id — an expiration entry belongs to a single
  // document, so this intentionally does not nest under `keys.record(id)`.
  documentExpirationsSegment: 'document_expirations',
  documentExpirations: docId => [keys.documentExpirationsSegment, { documentId: parseInt(docId, 10) }],
  // Scoped by gpt request id only — document-expiration extractions are not tied to a record.
  gptRequest: gptRequestId => ['gpt_requests', { gptRequestId: parseInt(gptRequestId, 10) }],
  // Shared trailing segment, so anything that changes the data the preview is derived from can
  // invalidate every cached preview without knowing which agent(s) they were keyed to.
  agentRemovalPreviewSegment: 'agent-removal-preview',
  recordAgentRemovalPreviews: id => [...keys.record(id), keys.agentRemovalPreviewSegment],
  // Mutation key, so the modal can tell when a removal is in flight and stop previewing.
  removeRecordAgentMutation: id => ['remove-record-agent', { recordId: parseInt(id, 10) }],
  recordAgentRemovalPreview: (id, agentUserId) => [
    ...keys.recordAgentRemovalPreviews(id),
    { agentUserId: parseInt(agentUserId, 10) }
  ]
};

export default keys;
